<template>
  <v-card>
    <v-card-title class="headline">Ett fel uppstog!</v-card-title>

    <v-card-text>
      {{ errorMessage }}
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="confirm">
        Ladda om
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ErrorModal',

  computed: {
    errorMessage() {
      return this.$store.get('app/errorMessage')
    }
  },

  methods: {
    confirm() {
      location.reload()
    }
  }
}
</script>
